import React from 'react';

export const QualitySelector = ({ value, onChange, type = 'video', disabled = false, id = 'quality' }) => {
    if (type === 'audio') {
        return (
            <select
                id={id}
                value={value}
                onChange={onChange}
                disabled={disabled}
            >
                <option value="128">128 kbps (Good)</option>
                <option value="192">192 kbps (Better)</option>
                <option value="320">320 kbps (Best)</option>
            </select>
        );
    }

    // Video quality
    return (
        <select
            id={id}
            value={value}
            onChange={onChange}
            disabled={disabled}
        >
            <option value="auto">Auto (Best Available)</option>
            <option value="1080">1080p</option>
            <option value="720">720p</option>
            <option value="480">480p</option>
            <option value="360">360p</option>
        </select>
    );
};
